import React from 'react';
import PrivateRoute from './PrivateRoute';
import Test1 from 'labs/Test1';

const LabRoutes = [
  <PrivateRoute path="/labs/test1" component={Test1} access={['agency']} />,
];
export default LabRoutes;
